/**
 * TODO: this is deprecated. Please use the native JS array flat() function instead (DASHEX-3441).
 *
 * @template T
 * @param {Array<Array<T>>} arrayOfArrays
 * @returns {Array<T>}
 */
export default function flatten(arrayOfArrays) {
  return arrayOfArrays && arrayOfArrays.reduce((out, array) => {
    if (array && array.length > 0) {
      return [...out, ...array];
    } else {
      return out;
    }
  }, []);
}